import React from 'react';
import Modal from "../../../component/modal/ModalTemplate";
import { PRIMARY_BTN, SECONDARY_BTN, FOOTER_END } from "./modalStyle";

interface BussinessFileModalProps {
    isOpen: boolean;
    onRequestClose: () => void;
    comRegistImgLink?: string;
}

const BussinessFileModal: React.FC<BussinessFileModalProps> = ({ isOpen, onRequestClose, comRegistImgLink }) => {
    return (
        <Modal
            open={isOpen}
            handleClose={onRequestClose}
            modalTitle="사업자 등록증"
            className="react-modal"
        >
            <div className="modal-body">
                <div className="tw-mx-auto tw-flex tw-max-h-[70vh] tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-lg tw-bg-[#F6F9FC]">
                    <img className="tw-max-h-[70vh] tw-w-full tw-object-contain" src={comRegistImgLink} alt="사업자 등록증" />
                </div>
            </div>
            <div className={FOOTER_END}>
                <button type="button" className={PRIMARY_BTN} onClick={onRequestClose}>확인</button>
                <button type="button" className={SECONDARY_BTN} onClick={onRequestClose}>취소</button>
            </div>
        </Modal>
    );
};

export default BussinessFileModal;
